import { label } from '../typography';
const FormLabelComponentStyle = {
    baseStyle: {
        ...label(),
        mb: 2,
        color: 'primary600',
    },
};
export default FormLabelComponentStyle;
